<template>
	<div>
		<div class="row">
			<div class="col-lg-12 mb-3">
				<b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
				<b-card :header="$t('general.commercial.change_orders.revision.title')" header-tag="h3" class="bg-default-card">
					<revision-control-table ref="rt" actionWidth='95px' @pressEdit="onEditRow" @pressDelete="onDeleteRow" @pressAdd="onAddRow" @pressReturn="onReturn" @pressParts="pressParts">
						<span slot="return">
							{{$t('general.buttons.return_to.return_to_change_orders')}}
						</span>
						<span slot="add">
							{{ $t('general.revision.create_button') }}
						</span>
					</revision-control-table>
				</b-card>
			</div>
		</div>

        <b-modal ref="saveModal" :title="actionTitle" size="lg" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_revisions'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.discipline') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedDisciplines"
                                :options="currentDiscipline"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isDisciplineLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onDisciplineSearch"
                                @input="updateDiscipline"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedDisciplines != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedDisciplines"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.discipline_id != null">
                        <div class="col-lg-4">
                            <label v-if="model.discipline_id == 1">{{ $t('table.isometric') }}</label>
                            <label v-else>{{ $t('table.drawing') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedDrawing"
                                :options="currentDrawing"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isDrawingLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="info" track-by="id"
                                
                                :selectLabel="''"
                                @search-change="onDrawingSearch"
                                @input="updateDrawing"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedDrawing != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedDrawing"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.reported_team') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedTeam"
                                :options="currentTeam"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isTeamLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onTeamSearch"
                                @input="updateTeam"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedTeam != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedTeam"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="this.model.reported_team_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.reported_user') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedUser"
                                :options="currentUser"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isUserLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onUserSearch"
                                @input="updateUser"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedUser != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedUser"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.charging_to') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedCompany"
                                :options="currentCompany"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isCompanyLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onCompanySearch"
                                @input="updateCompany"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedCompany != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedCompany"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.contact_person') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedPerson"
                                :options="currentPerson"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isPersonLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onPersonSearch"
                                @input="updatePerson"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedPerson != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedPerson"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.site_instruction_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedSiteInstruction"
                                :options="currentSiteInstruction"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isSiteInstructionLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="site_instruction_number" track-by="id"
                                :selectLabel="''"
                                @search-change="onSiteInstructionSearch"
                                @input="updateSiteInstruction"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedSiteInstruction != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedSiteInstruction"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.charging_status') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.charging_status">
                                <option v-for="charging_status in charging_statuses" :value="charging_status.code" :key="charging_status.code">{{charging_status.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.area') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" placeholder="" v-model="model.area">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.site_change_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" placeholder="" v-model="model.site_change_number">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.title') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" placeholder="" v-model="model.title">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.client_approved') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.client_approved" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.client_visited') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.client_visited" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.priority') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.priority">
                                <option v-for="priority in drawing_priority" :value="priority.name" :key="priority.name">{{priority.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.status') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.status">
                                <option v-for="status in statuses" :value="status.code" :key="status.code">{{status.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.estimated_value') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" placeholder="" v-model="model.estimated_value">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.schedule_influence') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2">
                            <toggle-button v-model="model.schedule_influence" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.engineering_needed') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.engineering_needed" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.material_needed') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.material_needed" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.painting_needed') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.painting_needed" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ndt_pwht_needed') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.ndt_pwht_needed" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.work_started') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button v-model="model.work_started" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.start_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.start_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.end_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.end_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.client_charge_order_nr') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" placeholder="" v-model="model.client_charge_order_number">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.subcontrator_charge_order_nr') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" placeholder="" v-model="model.subcontractor_change_order_number">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.value_confirmed') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" placeholder="" v-model="model.value_confirmed">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.date_confirmed') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.date_confirmed"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.revision_date"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.revision_number" disabled>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_description') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.revision_description"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_reason') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.revision_reason_setting"
								:options="currentReason"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isReasonLoading"
								:preserve-search="true"
								placeholder=""
								label="value" track-by="id"
								:selectLabel="''"
								@search-change="onReasonSearch"
							>   
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.revision_reason_setting != null && typeof model.revision_reason_setting.id != 'undefined' && model.revision_reason_setting.id != null"  
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedProjectSetting"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_remarks') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.revision_remarks"></textarea>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12">
                    <label>{{ $t('table.change_order_description') }}</label>
                    <textarea rows="5" maxlength="5000" class="form-control" v-model="model.description"></textarea>
                </div>

                <div class="col-lg-12">
                    <hr v-if="getData.getFiles.length > 0 && hasFilesReadPermission">
                    <div class="row mt-2" v-if="getData.getFiles.length > 0 && hasFilesReadPermission">
                        <div class="col-lg-12">
                            <label>{{ $t('table.uploaded_files') }}</label>
                        </div>
                        <div class="col-lg-6" v-for="file in getData.getFiles" :key="file.id">
                            <div class="card p-2">
                                <div style="width: 100%; display: block">
                                    <p 
                                        class="float-left customLink" 
                                        @click="onDownloadFile(file.id)" 
                                        :title="file.file_name"
                                    >
                                        {{file.file_name}}
                                    </p>
                                    <p 
                                        v-if="hasFilesDeletePermission"
                                        class="float-right p-0 m-0"
                                    >
                                        <i class='fa fa-2x fa-trash mt-2 text-danger sortable cursor-pointer' @click="onDeleteFile(file.id)"></i>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

		<revision-control-modal :model.sync="this.model" ref="addModal" :title="actionTitle" settingType="reason_for_revision" @ok="saveAction"/>

		<confirm-dialog ref="deleteModal" :title="actionTitleDelete" @buttonClick="deleteAction">
			{{ delete_message }}
		</confirm-dialog>
	</div>
</template>

<script>
import Vue from 'vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import miniToastr from 'mini-toastr';
import http from '@/libs/http';
import _ from 'lodash';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import Multiselect from 'vue-multiselect';
Vue.component(Multiselect);

import RevisionControlModal from '@/components/global/modals/RevisionControlModal.vue';
import RevisionControlTable from '@/components/global/tables/RevisionControlTable.vue';

export default {
	name: 'change_orders_revisioncontrol',
	components: {
		DataTable,
		ConfirmDialog,
		Multiselect,
		flatPickr,
		RevisionControlModal,
		RevisionControlTable,
	},
	data() {
		return {
			breadcrumbItems: [
				{
					text: Vue.i18n.translate('general.dashboard.title'),
					to: '/'
				},
				{
					text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
					to: '/project/'+this.$route.params.id,
				},
				{
					text: Vue.i18n.translate('general.commercial.title'),
					active: true
				},
				{
					text: Vue.i18n.translate('general.commercial.change_orders.title'),
					active: true
				},
				{
					text: Vue.i18n.translate('general.revision.title'),
					active: true
				}
			],
            model: {
                discipline_id: null,
                drawing_id: null,
                reported_team_id: null,
                reported_user_id: null,
                charging_to_client_id: null,
                contact_person_client_id: null,
                site_instruction_id: null,
                charging_status: null,
                area: null,
                title: null,
                description: null,
                site_change_number: null,
                client_approved: null,
                client_visited: null,
                priority: null,
                status: null,
                estimated_value: null,
                schedule_influence: null,
                engineering_needed: null,
                material_needed: null,
                insulation_needed: null,
                painting_needed: null,
                ndt_pwht_needed: null,
                other_services_needed: null,
                work_started: null,
                start_date: null,
                end_date: null,
                client_charge_order_number: null,
                subcontractor_change_order_number: null,
                value_confirmed: null,
                date_confirmed: null,
                
                revision_number: null,
				revision_date: null,
				revision_description: null,
				revision_reason: null,
				revision_reason_setting: null,
				revision_remarks: null,
            },

            isReasonLoading: false,
		    currentReason: [],

            row: null,
            actionTitle: null,
            tableNameTranslated: Vue.i18n.translate('general.revision.main_title'),

            selectedDisciplines: null,
            currentDiscipline: [],
            isDisciplineLoading: false,

            selectedDrawing: null,
            currentDrawing: [],
            isDrawingLoading: false,

            selectedTeam: null,
            currentTeam: [],
            isTeamLoading: false,

            selectedUser: null,
            currentUser: [],
            isUserLoading: false,

            selectedCompany: null,
            currentCompany: [],
            isCompanyLoading: false,

            selectedPerson: null,
            currentPerson: [],
            isPersonLoading: false,

            selectedSiteInstruction: null,
            currentSiteInstruction: [],
            isSiteInstructionLoading: false,

            actionTitleDelete: '',
            delete_message: '',

            file_id: null,
            isFileDelete: false,

            hasFilesReadPermission: false,
            hasFilesDeletePermission: false,
            getData: {
                getFiles: [],
            }
        }
	},
	mounted() {
		this.$refs.rt.load('change_order?project_id='+this.$route.params.id+'&filters[parent_change_order_id]='+ this.$route.params.id2);

        this.hasFilesReadPermission   = this.$store.getters.hasPermission(['files'], ['read']);
        this.hasFilesDeletePermission = this.$store.getters.hasPermission(['files'], ['delete']);
	},
    computed: {
        charging_statuses: {
            get: function () {
                let charging_statuses = this.$store.getters.getChargingStatuses;
                return charging_statuses;
            }
        },
        statuses: {
            get: function () {
                let statuses = this.$store.getters.getChangeOrderStatuses;
                return statuses;
            }
        },
        drawing_priority: {
            get () {
                let drawing_priority = this.$store.getters.getDrawingPriority;
                return drawing_priority;
            }
        }
    },
    watch: {
        charging_statuses: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        statuses: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        drawing_priority: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
	methods: {
		successMsg(msg) {
			miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
		},
		errorMsg(msg) {
			miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
		},
        clearSearches() {
            this.selectedDisciplines     = null;
            this.selectedDrawing         = null;
            this.selectedTeam            = null;
            this.selectedUser            = null;
            this.selectedCompany         = null;
            this.selectedPerson          = null;
            this.selectedSiteInstruction = null;

            this.currentDiscipline      = [];
            this.currentDrawing         = [];
            this.currentTeam            = [];
            this.currentUser            = [];
            this.currentCompany         = [];
            this.currentPerson          = [];
            this.currentSiteInstruction = [];

            this.getData.getFiles = [];
            this.$nextTick(() => {
                if (typeof this.$refs.document != 'undefined') {
                    this.$refs.document.removeAllFiles();
                }
            });
        },
        findLastRevisionNumber(request) {
			return new Promise(resolve => {
				http.route(request).get().then(response => {
                    if (!response.isError) {
					    this.model.revision_number = response.data+1;
                    } else {
					    this.model.revision_number = null;
					}
					resolve(this.model.revision_number);
				});
			});
		},
		async onAddRow() {
			this.actionTitle = Vue.i18n.translate('general.revision.create_button');
			this.row = null;
			this.model.revision_remarks = null;
			this.model.revision_reason = null;
			this.model.revision_reason_setting = null;
			this.model.revision_description = null;
			this.model.revision_date = null;

			await this.findLastRevisionNumber('change_order/'+this.$route.params.id2+'/maxrevision?project_id='+this.$route.params.id);
			this.$refs.addModal.show();
		},
        onEditRow(row) {
			this.actionTitle = Vue.i18n.translate('general.revision.edit_button');
            this.currentDrawing = [];
			this.row = row;
            this.clearSearches();
            
            if (this.hasFilesReadPermission) {
                this.onViewFiles(this.row.id);
            }

			this.model.discipline_id = this.row.discipline_id;
            this.model.drawing_id = this.row.drawing_id;
            this.model.reported_team_id = this.row.reported_team_id;
            this.model.reported_user_id = this.row.reported_user_id;
            this.model.charging_to_client_id = this.row.charging_to_client_id;
            this.model.contact_person_client_id = this.row.contact_person_client_id;
            this.model.site_instruction_id = this.row.site_instruction_id;
            this.model.charging_status = this.row.charging_status;
            this.model.charging_status = this.row.charging_status;
            this.model.area = this.row.area;
            this.model.title = this.row.title;
            this.model.description = this.row.description;
            this.model.site_change_number = this.row.site_change_number;
            this.model.client_approved = Boolean(this.row.client_approved);
            this.model.client_visited = Boolean(this.row.client_visited);
            this.model.priority = this.row.priority;
            this.model.status = this.row.status;
            this.model.estimated_value = this.row.estimated_value;
            this.model.schedule_influence = Boolean(this.row.schedule_influence);
            this.model.engineering_needed = Boolean(this.row.engineering_needed);
            this.model.material_needed = Boolean(this.row.material_needed);
            this.model.insulation_needed = Boolean(this.row.insulation_needed);
            this.model.painting_needed = Boolean(this.row.painting_needed);
            this.model.ndt_pwht_needed = Boolean(this.row.ndt_pwht_needed);
            this.model.other_services_needed = Boolean(this.row.other_services_needed);
            this.model.work_started = Boolean(this.row.work_started);
            this.model.start_date = this.row.start_date;
            this.model.end_date = this.row.end_date;
            this.model.client_charge_order_number = this.row.client_charge_order_number;
            this.model.subcontractor_change_order_number = this.row.subcontractor_change_order_number;
            this.model.value_confirmed = this.row.value_confirmed;
            this.model.date_confirmed = this.row.date_confirmed;
            this.selectedDisciplines = this.row.discipline;
            this.selectedDrawing = this.row.drawing;
            this.selectedUser = this.row.reported_user;
            this.selectedTeam = this.row.reported_team;
            this.selectedPerson = this.row.contact_person_client;
            this.selectedSiteInstruction = this.row.site_instruction;
            this.selectedCompany = this.row.charging_to_client;

			this.model.revision_number = row.revision_number;
			this.model.revision_remarks = row.revision_remarks;
			this.model.revision_reason = row.revision_reason;
			this.model.revision_description = row.revision_description;
			this.model.revision_reason_setting = row.revision_reason_setting;
			this.model.revision_date = row.revision_date;

			this.$refs.saveModal.show();
		},
        saveAction(e) {
            e.preventDefault();

            if (this.model.revision_reason_setting == null) {
                this.model.revision_reason_setting = { 'id': null }
            }

            let data = {
                project_id: this.$route.params.id,
                discipline_id: this.model.discipline_id,
                drawing_id: this.model.drawing_id,
                reported_team_id: this.model.reported_team_id,
                reported_user_id: this.model.reported_user_id,
                contact_person_client_id: this.model.contact_person_client_id,
                site_instruction_id: this.model.site_instruction_id,
                charging_to_client_id: this.model.charging_to_client_id,
                charging_status: this.model.charging_status,
                area: this.model.area,
                title: this.model.title,
                description: this.model.description,
                site_change_number: this.model.site_change_number,
                client_approved: this.model.client_approved,
                client_visited: this.model.client_visited,
                priority: this.model.priority,
                status: this.model.status,
                estimated_value: this.model.estimated_value,
                schedule_influence: this.model.schedule_influence,
                engineering_needed: this.model.engineering_needed,
                material_needed: this.model.material_needed,
                insulation_needed: this.model.insulation_needed,
                painting_needed: this.model.painting_needed,
                ndt_pwht_needed: this.model.ndt_pwht_needed,
                other_services_needed: this.model.other_services_needed,
                work_started: this.model.work_started,
                start_date: this.model.start_date,
                end_date: this.model.end_date,
                client_charge_order_number: this.model.client_charge_order_number,
                subcontractor_change_order_number: this.model.subcontractor_change_order_number,
                value_confirmed: this.model.value_confirmed,
                date_confirmed: this.model.date_confirmed,

                revision_number: this.model.revision_number,
                revision_remarks: this.model.revision_remarks,
                revision_reason: this.model.revision_reason_setting.id,
                revision_description: this.model.revision_description,
                revision_date: this.model.revision_date,

                id: this.model.id,
                from_revision_control: 1,
            }

            Object.keys(data).forEach(key => {
                if (data[key] === '') {
                    data[key] = null;
                }
            });

            if (this.row) {
                data['date'] = data.date ? data.date : null;
                data['id'] = this.$route.params.id2;
                http.route('change_order/' + this.row.id).patch(data, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.$refs.rt.refresh();
                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                data['id'] = this.$route.params.id2;
                http.route('change_order').post(data, true).then(response => {
                    if (!response.isError) {
                        // let id = response.data.id;
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                        this.$refs.rt.refresh();
                        this.$refs.addModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
		},
        onViewFiles (id) {
            this.getData.getFiles.length = 0;
            let data = http.route('file?filters[change_order_id]=' + id).get();
            data.then(response => {
                if(response.data == false) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.getData.getFiles = response.data;
                }
            });
        },
        onDownloadFile (id) {
            let data = http.route('file/' + id).get({export_pdf: 1}, true);
            data.then(response => {
                if (!response.isError) {
                    this.successMsg(Vue.i18n.translate('messages.file.file_download'));
                    let data = http.route('get_content/file/'+response.data.id+'/'+response.data.file_name).downloadPdf({}, response.data.file_name).then(res => {});
                } else {
                    this.errorMsg(Vue.i18n.translate('messages.file.error_download'));
                }
            });
        },
		onDeleteRow(row, index) {
			this.actionTitle = Vue.i18n.translate('general.revision.delete_button');
			this.row = row;
			this.$refs.deleteModal.show();
		},
        onDeleteRow (row, index) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.delete_message = Vue.i18n.translate('messages.delete');
            this.row = row;
            this.file_id = null;
            this.isFileDelete = false;
            this.$refs.deleteModal.show();
        },
        onDeleteFile (id) {
            this.actionTitleDelete = Vue.i18n.translate('messages.delete_file_title');
            this.delete_message = Vue.i18n.translate('messages.delete_file');
            this.file_id = id;
            this.isFileDelete = true;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                if (this.isFileDelete == true) {
                    this.row.file_id = null;
                    let data = http.route('change_order/' + this.row.id).patch(this.row, true);
                    data.then(response => {
                        if(response.isError == false) {
                            this.$refs.rt.refresh(-1);
                            let data = http.route('file/' + this.file_id).delete();
                            data.then(response => {
                                this.$refs.saveModal.hide();
                                this.successMsg(Vue.i18n.translate('messages.deleted_file_message'));
                            });
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                } else if (this.isFileDelete == false) {
                    let data = http.route('change_order/' + this.row.id).delete();
                    data.then(response => {
                        if (response.isError == false) {
                            this.$refs.rt.refresh(-1);
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                }
            }
            
            this.$refs.deleteModal.hide();
        },
        onReturn() {
			this.$router.push({name: 'change_orders', params: {id:this.$route.params.id}});
		},
        pressParts (row) {
			this.$router.push({name: 'changeorders_parts', params: {id:this.$route.params.id, id2:row.id}});
		},
        onDisciplineSearch(search) {
            if (search == '') {
                this.currentDiscipline = [];
                
                return false;
            }

            this.isDisciplineLoading = true;
            this.searchDiscipline(search, this);
        },
        searchDiscipline: _.debounce((search, vm) => {
            let data = http.route('discipline?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentDiscipline = response.data;
                }
                vm.isDisciplineLoading = false;
            });
        }, 500),
        updateDiscipline(discipline) {
            this.selectedDrawing = null;
            this.currentDrawing = [];
            this.model.drawing_id = null;

            if (discipline == null) {
                this.model.discipline_id = null;
            } else {
                this.model.discipline_id = discipline.id;
                http.route('drawing?project_id='+this.$route.params.id +'&filters[parent_drawing_id]=null&filters[discipline_id]='+this.model.discipline_id).get().then(response => {
                    if(response.data != false) {
                        this.currentDrawing = response.data;
                        this.currentDrawingNoSelect = true;
                    }
                });
            }
        },
        clearSelectedDisciplines () {
            this.selectedDisciplines = null;
            this.model.discipline_id = null;
        },
        onDrawingSearch(search) {
            if (search == '') {
                this.currentDrawing = [];
                
                return false;
            }

            this.isDrawingLoading = true;
            this.searchDrawing(search, this);
        },
        searchDrawing: _.debounce((search, vm) => {
            if (vm.model.discipline_id != null) {
                let data = http.route('drawing?project_id='+vm.$route.params.id +'&filters[parent_drawing_id]=null&filters[discipline_id]='+vm.model.discipline_id+'&get_all=1&search_select=' + search).get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentDrawing = response.data;
                    }
                    vm.isDrawingLoading = false;
                });
            }
        }, 500),
        updateDrawing(drawing) {
            this.model.drawing_id = (drawing != null) ? drawing.id : null;
        },
        clearSelectedDrawing () {
            this.selectedDrawing  = null;
            this.model.drawing_id = null;
        },
        onTeamSearch(search) {
            if (search == '') {
                this.currentTeam = [];

                return false;
            }

            this.isTeamLoading = true;
            this.searchTeam(search, this);
        },
        searchTeam: _.debounce((search, vm) => {
            let data = http.route('team?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentTeam = response.data;
                }
                vm.isTeamLoading = false;
            });
        }, 500),
        updateTeam(team) {
            this.currentUser = [];
            this.clearSelectedUser();

            this.model.reported_team_id = (team != null) ? team.id : null;

            if (team != null) {
                http.route('team/' + team.id +'/members?project_id='+this.$route.params.id).get().then(response => {
                    if (response.data != false) {
                        this.selectedUser = null;
                        this.currentUser = response.data;
                    }
                });
            }
        },
        clearSelectedTeam () {
            this.selectedTeam           = null;
            this.model.reported_team_id = null;
        },
        onUserSearch(search) {
            if (search == '') {
                this.currentUser = [];
                
                return false;
            }

            if (this.model.reported_team_id != null) {
                this.isUserLoading = true;
                this.searchUser(search, this);
            }
        },
        searchUser: _.debounce((search, vm) => {
            let data = http.route('team/' + vm.model.reported_team_id +'/members?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentUser = response.data;
                }
                vm.isUserLoading = false;
            });
        }, 500),
        updateUser(user) {
            this.model.reported_user_id = (user != null) ? user.user_id : null;
        },
        clearSelectedUser () {
            this.selectedUser           = null;
            this.model.reported_user_id = null;
        },
        onCompanySearch(search) {
            if (search == '') {
                this.currentCompany = [];
                
                return false;
            }

            this.isCompanyLoading = true;
            this.searchCompany(search, this);
        },
        searchCompany: _.debounce((search, vm) => {
            let data = http.route('company?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentCompany = response.data;
                }
                vm.isCompanyLoading = false;
            });
        }, 500),
        updateCompany(company) {
            this.model.charging_to_client_id = (company != null) ? company.id : null;
        },
        clearSelectedCompany () {
            this.selectedCompany             = null;
            this.model.charging_to_client_id = null;
        },
        onPersonSearch(search) {
            if (search == '') {
                this.currentPerson = [];
                
                return false;
            }

            this.isPersonLoading = true;
            this.searchPerson(search, this);
        },
        searchPerson: _.debounce((search, vm) => {
            let data = http.route('user/getall?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentPerson = response.data;
                }
                vm.isPersonLoading = false;
            });
        }, 500),
        updatePerson(user) {
            this.model.contact_person_client_id = (user != null) ? user.id : null;
        },
        clearSelectedPerson () {
            this.selectedPerson                 = null;
            this.model.contact_person_client_id = null;
        },
        onSiteInstructionSearch(search) {
            if (search == '') {
                this.currentSiteInstruction = [];
                
                return false;
            }

            this.isSiteInstructionLoading = true;
            this.searchSiteInstruction(search, this);
        },
        searchSiteInstruction: _.debounce((search, vm) => {
            let data = http.route('siteinstruction?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentSiteInstruction = response.data;
                }
                vm.isSiteInstructionLoading = false;
            });
        }, 500),
        updateSiteInstruction(user) {
            this.model.site_instruction_id = (user != null) ? user.id : null;
        },
        clearSelectedSiteInstruction () {
            this.selectedSiteInstruction   = null;
            this.model.site_instruction_id = null;
        },
        onReasonSearch(search) {
            if (search == '') {
                this.currentReason = [];
                
                return false;
            }

			this.isReasonLoading = true;
			this.searchReason(search, this);
		},
		searchReason: _.debounce((search, vm) => {
			let data = http.route("projectsetting?project_id="+vm.$route.params.id+"&filters[type]=reason_for_revision&get_all=1&search_select=" + search).get();
			data.then(response => {
                if (response.data != false) {
                    vm.currentReason = response.data;
                }
                vm.isReasonLoading = false;
			});
		}, 500),
        clearSelectedProjectSetting () {
			this.model.revision_reason_setting = null;
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/project/commercial/change_orders/change_orders_revisioncontrol.vue